/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TriggerParamOptionDto } from './TriggerParamOptionDto';
export type ProcessDefinitionPutTriggerParamV1Dto = {
  /**
   * The name of the trigger parameter
   */
  name: string;
  /**
   * The value of the trigger parameter
   */
  value: Record<string, any>;
  /**
   * The type of the trigger parameter
   */
  type?: ProcessDefinitionPutTriggerParamV1Dto.type | null;
  /**
   * The default value of the trigger parameter
   */
  default?: string | null;
  /**
   * The available options for the trigger parameter
   */
  options?: Array<TriggerParamOptionDto> | null;
  /**
   * Admin explanation for the trigger parameter
   */
  adminExplanation?: string | null;
  /**
   * The source for dynamically loading options
   */
  optionSource?: string | null;
};
export namespace ProcessDefinitionPutTriggerParamV1Dto {
  /**
   * The type of the trigger parameter
   */
  export enum type {
    STRING = 'string',
    SELECT = 'select',
    BOOLEAN = 'boolean',
  }
}
